module.exports = __webpack_public_path__ + "media/images/flag-pt-819162b9d6f525a7d4c32499e3ee10ee.svg";